<template>
    <span>
        <span class="text-primary">
            <i
                class="fa fa-hourglass-half fa-lg icon-button"
                title="Exibir Timeline"
                @click.stop="mostrarTimeline()"
            ></i>
        </span>
        <b-modal
            hide-footer
            size="xl"
            v-model="mostrarModal"
            @show="obterTimeLine()"
            title="TIMELINE"
        >
            <time-line :itens="itensTimeLine" :isModal="true"></time-line>
        </b-modal>
    </span>
</template>

<script>
import TimeLine from './../../../../shared/components/TimeLine'

export default {
    props: {
        etapasServicos: {
            type: Object,
            default: () => ({})
        },
        etapa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            itensTimeLine: null
        }
    },

    methods: {
        mostrarTimeline() {
            this.mostrarModal = true
        },

        obterTimeLine() {
            this.etapasServicos
                .obterTimeLine(this.etapa.etapaId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.itensTimeLine = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter timeline',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                })
        }
    },

    components: {
        TimeLine
    }
}
</script>